/* VNSTRA: zet het video- en rekenhulpblok binnen het productgrid, na een aantal kaarten.
   Geen tweede grid, geen dubbele producten, geen extra netwerkverzoeken.
   De blokken worden verplaatst, niet gekopieerd, dus hun knoppen en invoervelden blijven werken.
   Vervangt het thema het grid na een filter- of paginaactie, dan zet deze code ze er opnieuw in. */
(function () {
  if (window.__vnstraInline) return;
  window.__vnstraInline = true;
  if (window.Shopify && window.Shopify.designMode) return;

  var PLAN = [
    { sel: '[data-vnstra-video]', after: 4 },
        { sel: '[data-vnstra-rekenhulp]', after: 8 }
  ];
  var nodes = [];

  function collect() {
    if (nodes.length) return;
    for (var i = 0; i < PLAN.length; i++) {
      var el = document.querySelector(PLAN[i].sel);
      if (el) nodes.push({ el: el, after: PLAN[i].after });
    }
  }

  function run() {
    collect();
    if (!nodes.length) return;
    /* Alleen op collectiepagina's en alleen in het hoofdgrid: nooit in sliders zoals
       "Recent bekeken" of de cross-sell op productpagina's (fix 09-10-2026). */
    if (!/hdt-page-type-collection/.test(document.body.className)) return;
    var firstCard = null;
    var all = document.querySelectorAll('.hdt-card-product');
    for (var k = 0; k < all.length; k++) {
      var c = all[k];
      if (c.classList.contains('hdt-slider__slide')) continue;
      if (c.closest('hdt-slider, hdt-slider-wait, product-recently, [class*="vnstra-"]')) continue;
      firstCard = c;
      break;
    }
    if (!firstCard) return;
    var grid = firstCard.parentElement;
    if (!grid) return;

    for (var i = 0; i < nodes.length; i++) {
      var item = nodes[i];
      if (item.el.parentElement === grid) continue;
      var cards = grid.querySelectorAll(':scope > .hdt-card-product');
      if (cards.length <= item.after) continue;
      grid.insertBefore(item.el, cards[item.after]);
      item.el.classList.add('vnstra-inlined');
    }
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  function boot() {
    run();
    if (!window.MutationObserver) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
